import { useSyncExternalStore } from "react";
import { isNativeApp } from "./platform";

const ADMIN_DESKTOP_QUERY = "(min-width: 1280px)";
export const INVALID_LOGIN_MESSAGE = "Invalid username or password.";

/** Request-time presentation hint, not proof of the caller's device identity. */
export function clientSurface(): "native" | "desktop-web" | "compact-web" {
  if (isNativeApp()) return "native";
  return window.matchMedia(ADMIN_DESKTOP_QUERY).matches ? "desktop-web" : "compact-web";
}

export function isDesktopAdminClient(): boolean {
  return clientSurface() === "desktop-web";
}

function subscribeDesktopLayout(onChange: () => void): () => void {
  const media = window.matchMedia(ADMIN_DESKTOP_QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

/** Recheck on resize before rendering protected content, including restored sessions. */
export function useDesktopAdminAccess(): boolean {
  return useSyncExternalStore(subscribeDesktopLayout, isDesktopAdminClient);
}
